import React from "react";
import "./App.scss";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import DefaultLayout from "./layouts/DefaultLayout";
import theme from "./theme";
import { SessionProvider } from "./contexts/SessionContext";
import AppInitializer from "./AppInitializer";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <SessionProvider>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute requireAuth={true}>
                  <DefaultLayout>
                    <AppInitializer />
                  </DefaultLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </SessionProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
